import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ExtendedLeadBlockData from '../../../Models/Content/ExtendedLeadBlockData';
import ExtendedLead from './extendedLead';
import {isMobile} from 'react-device-detect';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';

export default class ExtendedLeadBlock extends EpiComponent<ExtendedLeadBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['extended-lead-block'];
    return (
      <div
        className={this.props.data.image.expandedValue?.url || this.props.data.mobileImage.expandedValue?.url ? 'ExtendedLeadBlock' : ''}>
        <div className={cssClasses.join(' ')}>
          <ExtendedLead iContent={this.props.data} context={this.getContext()} backgroundImage={getBackgroundImageProps(isMobile ? this.props.data.mobileImage : this.props.data.image, this.getContext())} />
        </div>
      </div>
    );
  }
}
